import React from "react";
import shopbookLogo from "@/assets/shopbook_logo.png";

export function Logo({
  size = 32,
  mark = true,
  wordmark = true,
  tagline = false,
  auth = false,
  inverse = false,
  className = "",
}) {
  return (
    <div className={`flex items-center ${auth ? "gap-1.5" : "gap-3"} ${className}`}>
      {mark && (
        <div
          className={`inline-flex shrink-0 items-center justify-center overflow-hidden bg-background ${
            auth ? "rounded-lg" : "rounded-[10px] ring-1 ring-border/70"
          }`}
          style={{ width: size, height: size }}
          aria-hidden
        >
          <img
            src={shopbookLogo}
            alt=""
            className="block"
            style={{
              width: size,
              height: size,
              objectFit: "contain",
              objectPosition: "center",
              transform: `scale(${auth ? 1.1 : 1.3})`,
              transformOrigin: "center",
            }}
          />
        </div>
      )}
      {wordmark && (
        <div className="flex flex-col leading-none">
          <span
            className={`${auth ? "text-lg leading-5" : "text-[16px]"} font-bold tracking-[-0.02em] ${
              inverse ? "text-white" : "text-foreground"
            }`}
          >
            Shopbook
          </span>
          {tagline && (
            <span
              className={`${
                auth ? "mt-0.5 text-[10px] leading-3.5" : "mt-1 text-[10px] uppercase tracking-[0.18em]"
              } ${inverse ? "text-white/65" : "text-muted-foreground"}`}
            >
              Retail Operations
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default Logo;
